import React, { useEffect, useContext, createContext, useState } from 'react'
import clsx from 'clsx'
import { createTheme, ThemeProvider, Theme } from "@mui/material/styles";
import { makeStyles } from '@mui/styles'
import CssBaseline from '@mui/material/CssBaseline';
import { BooleanParam, useQueryParam, JsonParam, withDefault } from 'use-query-params'
import TopBar from '../../components/top_bar'
import { SocketTable } from '../../components/socket_table'
import { socket, SocketContext } from '../../contexts/socket'
import { LatencyIndicator } from '../../components/latency_indicator';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { get_userinfo, get_schedule, get_schedule_by_user, UserInfo, ScheduleByUserEntry, ScheduleEntry, get_testSemids } from '../../api'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import SemidDisplay from '../../components/semid_display';

import apiClient from '../../utils/http-common';
import { TextField, Button, Container, Box, Grid, Paper, Link, AppBar, Toolbar, Typography, Tooltip, FormControl, FormControlLabel, Avatar, Input, InputLabel } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import Banner from '../../components/banner';
import { getCurrentUser } from '../../services/auth-service';
import { useAuth } from '../../contexts/AuthContext';
import { MAX_WIDTH } from '../../App'
import { Redirect, useHistory } from 'react-router-dom';
import axios from '../../api/axios';
import { responseInterceptor } from 'http-proxy-middleware';


function Dashboard() {
  const history = useHistory();

  const { user, token, loading, loggedIn, watchDate } = useAuth();

  useEffect(() => {
    
    return () => {
      // UnMounting
      console.log('Unmounting Gui')
    }
  }, [user])
  
  const API_URL = `${process.env.REACT_APP_KAH_SERVER_URL}/rti-gui/night_schedule`;
  const now_date = dayjs.utc().format('YYYY-MM-DD')
  const [ schedule, setSchedule ] = useState({})
  const [ allSemids, setAllSemids ] = useState([])
  const [ sloading, setSLoading ] = useState(true) // Loading Schedule
  
  const params = {
    "date": now_date,
    "range": "3:10",
  }


  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  useEffect(() => {
    if (token) {
      axios.post(API_URL, params, config)
        .then(data => {
          setSchedule(data.data);
          setSLoading(false);

          printSchedule();
        }).catch( err => {
          console.log(err);
        });
      
      const fdata = new FormData();
      const semid_params = {
        "obs_date": now_date,
        "userid": user?.userid ? user?.userid : ""
      }
      fdata.append("obs_date", now_date)
      fdata.append("userid", user?.userid ? user?.userid : "")
      const getSemParams = {

      }

let data = new FormData();
data.append('obs_date', '2023-12-14');
data.append('userid', 'koaadmin');

let fconfig = {
  method: 'post',
  maxBodyLength: Infinity,
  url: `${process.env.REACT_APP_KAH_SERVER_URL}/rti-gui/getSemids`,
  headers: { 
    'Authorization': `Bearer ${token}`, 
   'Content-Type': 'multipart/form-data',
  },
  data : data
};

axios.post(fconfig.url, data, {headers: fconfig.headers})
.then((response) => {
  console.log(JSON.stringify(response.data));
  console.log(response.data);
  setAllSemids(response.data.ALL_SEMIDS.map((x:any) => x.SEMID ));
  console.log(allSemids)
})
.catch((error) => {
  console.log(error);
});

      console.log("schedule")
      console.log(schedule)
    }

  },[ token, user ])

  useEffect( () => {
     if (!sloading) {
         printSchedule();
     }
  }, [ sloading ])

  const printSchedule = () => {
    let result = "";
    if (!sloading) { 
    for ( const i in schedule ) {
      let isToday = watchDate == `${i}` ? true : false ;
      result += `<div${ isToday ? ' class="daily__today"' : ""}><h2>${i}</h2><div>`; 
      Object.values(schedule[i as keyof Object]).forEach( (x, y) => {
        const ss = allSemids ? allSemids : [];
        console.log(ss)
        console.log(x._semid)
	const authzd_semid = ss.filter( (x1) => x1 == x._semid ).length > 0 ? true : false ;
        result += `<p key=${x._instr}:${x._semid} ${ authzd_semid ? 'class="authorized_semid"' : "" }>${x._instr}:${x._semid}</p>`;  
      })
      result += `</div></div>`; 
    }

    }
    return ( sloading ? 
        <Container><p>Downloading list of recent Programs....</p></Container> :
        <div className='daily__semids' dangerouslySetInnerHTML={{__html: result}}></div>
      )
  }

  return (
    <Container>
      <div>
        <h1>Dashboard</h1>
      </div>
      <h3>Scheduled Programs</h3>
      <Paper>
        <div>
          { printSchedule() }
        </div>
      </Paper>
      <br/>
      <br/>
      <br/>
      <br/>
    </Container>
  )
}

export default Dashboard;

